<main>
  <div class="grid-container">
    <h1 id="errorPageTitle">{{ "reaccom.errorPageTitle" | translate }}</h1>
    <!-- </div>
  <div class="table-cloth __white"> -->
    <!-- <div class="grid-container"> -->
    <div class="callout alert" role="alert" aria-labelledby="alert1">
      <h2 id="alert1">{{'reaccom.errorPagePleaseWait' | translate}}</h2>
      <p >{{'reaccom.errorPageNeedHelp' | translate}}</p>
      <ul>
        <li >
          <span >{{'reaccom.errorPageforTravelAssistance' | translate}}</span>
          <a id="contactRes" class="aa-pop-win-med" href="/i18n/contactAA/contact-reservations.jsp">{{'reaccom.errorPageContactReservations' | translate}}
            <span class="hidden-accessible">Opens in a new window</span> <span aria-hidden="true" class="icon-newpage"></span></a>
        </li>
        <li>
          <span >{{'reaccom.errorPageforAwardTravel' | translate}}</span>
          <a id="contactAA" class="aa-pop-win-med" href="/i18n/contactAA/contact-aadvantage-customer-service.jsp">{{'reaccom.errorPageContactAAdvantage' | translate}}
          <span class="hidden-accessible">Opens in a new window</span> <span aria-hidden="true" class="icon-newpage"></span></a></li>
      </ul>
    </div>
  </div>
</main>
